import { validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, ESTADO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    ESTADO_ENDPOINT
  ]);
}

export async function fetchPaginate(params = []) {
  const validatedQueryParams = validateQueryParams(params);
  return doGetQCXRequest([ESTADO_ENDPOINT, 'filter/pagination'], validatedQueryParams);
}

export async function checkForDuplicates(data) {
  return doPostQCXRequest([ESTADO_ENDPOINT, 'check-duplicate'], data);
}

export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      ESTADO_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    ESTADO_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [ESTADO_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [ESTADO_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [ESTADO_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [ESTADO_ENDPOINT],
    id
  );
}
